import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { formatSinceTime, downloadConnector, navigateTo } from '@helpers';
import { scale } from '@components/frame';

import { font } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import Svg from '@styles/icons/svg';
import Button from '@styles/buttons';

export const DownloadBlock = ({ C }) => {
  return (
    <View style={{ alignItems: 'center' }}>
      <Text style={[font['Subhead 2'], { color: C('Label/Light/Primary'), textAlign: 'center', marginTop: scale(24) }]}>
        {i18n.t('If you have a running Connector, click on the button below to link it to your company.')}
      </Text>
      <Text style={[font['Subhead 2'], { color: C('Label/Light/Primary'), textAlign: 'center', marginTop: scale(36) }]}>
        {i18n.t('Otherwise, download and install the Connector.')}
      </Text>
      <View style={{ marginTop: scale(18) }}>
        <Button
          {...{
            variant: 'L',
            type: 'Primary',
            onPress: () => {
              navigateTo('Settings', { screen: 'LinkConnector' });
            },
          }}
        >
          {i18n.t('Link Connector')}
        </Button>
      </View>
      <View style={{ marginTop: scale(25) }}>
        <Button
          {...{
            variant: 'L',
            type: 'Only Text Link',
            onPress: downloadConnector,
          }}
        >
          {i18n.t('Download Connector')}
        </Button>
      </View>
    </View>
  );
};

const NoConnector = ({ C, time }) => {
  return (
    <View style={{ alignItems: 'center', justifyContent: 'center', flex: 1, backgroundColor: C('Background/Light/Detail') }}>
      <View style={{ alignItems: 'center', width: scale(330) }}>
        <View style={{ alignItems: 'center' }}>
          <Text style={[font['Large Title'], { color: C('Label/Light/Primary') }]}>{i18n.t('No Connector')}</Text>
          {time && (
            <Text style={[font['Body Extra Large'], { color: C('Label/Light/Primary'), marginTop: scale(4) }]}>
              {i18n.t('Since')} {formatSinceTime(time)}
            </Text>
          )}
        </View>
        <View style={{ marginTop: scale(36) }}>
          <Svg icon="noConnectorLarge" width={scale(160)} height={scale(110)} color="Label/Light/Error" />
        </View>
        <DownloadBlock {...{ C }} />
      </View>
    </View>
  );
};

export default ColorWrapper(NoConnector);
